import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8091/api/v1";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

api.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("auth-storage"))?.state?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const toWebSocketUrl = (path) => {
  const wsBase = API_BASE_URL.replace(/^http/, "ws");
  return `${wsBase}${path}`;
};

export const ingestApi = {
  // Health check
  checkHealth: () => api.get("/ingest/health"),

  // Presign & Session
  presign: (files) => api.post("/ingest/presigned", { files }),
  createSession: (files) => api.post("/ingest/sessions", { files }),
  listSessions: (params) => api.get("/ingest/sessions", { params }),
  getSession: (sessionId) => api.get(`/ingest/sessions/${sessionId}`),
  getPages: (sessionId) => api.get(`/ingest/sessions/${sessionId}/pages`),
  commitSession: (sessionId, pageIds) =>
    api.post(`/ingest/sessions/${sessionId}/commit`,
      pageIds && pageIds.length ? { page_ids: pageIds } : {}
    ),

  // Session/Page Management
  deleteSession: (sessionId) => api.delete(`/ingest/sessions/${sessionId}`),
  deletePage: (sessionId, pageId) =>
    api.delete(`/ingest/sessions/${sessionId}/pages/${pageId}`),
  updatePage: (sessionId, pageId, ocrPayload) =>
    api.put(`/ingest/sessions/${sessionId}/pages/${pageId}`, { ocr_payload: ocrPayload }),
  retryPage: (sessionId, pageId) =>
    api.post(`/ingest/sessions/${sessionId}/pages/${pageId}/retry`),

  // Notifications
  getUnreadNotifications: () => api.get("/notifications/unread-count"),
  listNotifications: (params) => api.get("/notifications", { params }),
  markNotificationRead: (notificationId) =>
    api.post(`/notifications/${notificationId}/read`),

  // WebSocket
  getWebSocketUrl: (sessionId) => toWebSocketUrl(`/ingest/ws/${sessionId}`),
};

export default ingestApi;
